import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

function ModalCreateUpdate({
	selectedItem,
	setSelectedItem,
	createUpdate,
	modalCreateUpdate,
	toggleModalCreateUpdate,
}) {
	const { t } = useTranslation()

	return (
		<Modal show={modalCreateUpdate} animation={false} centered size="md"
			dialogClassName="update-modal-width"
			onHide={() => toggleModalCreateUpdate()}>
			<Modal.Header closeButton>
				<Modal.Title>
					{!selectedItem.id ? <span>{t('create')}</span> : <span>{t('edit')}</span>}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
					<div className="form-group">
						<label>{t('code')}<span className="required-mark">*</span></label>
						<input type="text" className="form-control" name="code"
							disabled={!!selectedItem.id}
							value={selectedItem.code || ''}
							onChange={(e) => setSelectedItem({
								...selectedItem,
								'code': e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, ''),
							})} />
					</div>

					<div className="form-group">
						<label>{t('name2')}<span className="required-mark">*</span></label>
						<input type="text" className="form-control" name="name" autoFocus
							value={selectedItem.name || ''}
							onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
					</div>

					<div className="form-group">
						<label>{t('sort_order')}</label>
						<input type="number" className="form-control" name="sort_order"
							value={selectedItem.sort_order ?? 0}
							onChange={(e) => setSelectedItem({ ...selectedItem, 'sort_order': e.target.value })} />
					</div>

					<div className="form-group">
						<label>{t('status')}</label>
						<select className="form-select"
							value={selectedItem.status ?? 1}
							onChange={(e) => setSelectedItem({ ...selectedItem, 'status': Number(e.target.value) })}>
							<option value={1}>{t('active')}</option>
							<option value={-1}>{t('not_active')}</option>
						</select>
					</div>

					<div className="d-flex w-100 mt-3 gap-2">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModalCreateUpdate()}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100"
							disabled={!selectedItem.code || !selectedItem.name}>
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default ModalCreateUpdate
